import React, {useState, useEffect, useMemo} from 'react';
import BScroll from '@better-scroll/core';
import PullDown from '@better-scroll/pull-down';
import PullUp from '@better-scroll/pull-up';

import './a.scss';
import {NoDate} from "../co";
import {Loading} from "../../loading";

BScroll.use(PullDown);
BScroll.use(PullUp);
export const XScrollView = ({
                                stopPropagation,
                                loading,
                                cls = '',
                                data,
                                item,
                                onDown,
                                y = 0,
                                onUp,
                                end,
                                noData = [],
                                children,
                                scroll,
                                trigger
                            }) => {
    const [top, sBk] = useState(false);
    const [ref, setRef] = useState(null);
    const ctx = useMemo(() => ({}), []);
    const [u, update] = useState(0);
    ctx.ld = loading;
    useEffect(() => () => {
        window.stopAni = 0;
        clearTimeout(ctx.t);
    }, [])
    const status = useMemo(() => ({
        isDown: 0,
        isUp: 0,
        stop: 0,
        t: 0
    }), [])
    const forceUpdate = () => {
        update(Math.random());
        clearTimeout(status.t);
        status.t = setTimeout(() => {
            if (!ctx.ld) {
                status.isUp = status.isDown = 0;
            }
            update(Math.random());
        }, 2000)
    }
    useEffect(() => {
        if (!loading && ctx.b) {
            status.isUp = status.isDown = 0;
            update(Math.random());
        }
    }, [loading])
    const [refresh, toTop] = useMemo(() => {
        return [
            () => {
                ctx.b && ctx.b.refresh()
            },
            () => ctx.b.scrollTo(0, 0, 300)
        ];
    }, [ctx, loading])
    useEffect(() => {
        if (ctx && ctx.b) ctx.b.refresh()
    }, [trigger, ctx])
    useEffect(() => {
        if (!children) {
            const t = setTimeout(refresh, 500);
            return () => {
                status.stop = 1;
                clearTimeout(t);
            }
        }
    }, [refresh, data])

    useEffect(() => {
        if (!ref) return;
        const b = ctx.b = new BScroll(ref, {
            resizePolling: 70,
            probeType: 3,
            tap: true,
            click: true,
            eventPassthrough: "horizontal",
            startY: y,
            scrollY: true,
            stopPropagation: stopPropagation,
            pullDownRefresh: !children,
            pullUpLoad: !children
        })
        if (scroll) {
            b.on('scroll', e => {
                const {aniTimer} = window;
                clearTimeout(aniTimer);
                window.stopAni = 1;
                window.aniTimer = setTimeout(() => {
                    window.stopAni = 0
                }, 500);
                scroll && requestAnimationFrame(() => {
                    scroll(e)
                });
            });
        }
        if (!children) {
            const sPw = (v) => {
                status.isDown = v;
                forceUpdate()
            }
            const sPu = (v) => {
                status.isUp = v;
                forceUpdate()
            }
            const h = ref.offsetHeight;
            const up = () => {
                ctx.b.finishPullUp();
                if (status.isDown || status.isUp) return;
                ctx.b.refresh();
                if (!end && onUp) onUp();
                sPu(true);
                sPw(false);
            }
            b.on('pullingUp', up)
            b.on('pullingDown', () => {
                ctx.b.finishPullDown()
                ctx.b.refresh();
                if (status.isDown || status.isUp) return;
                if (onDown) onDown()
                sPw(true);
                sPu(false);
            });
            b.on('scroll', ({y}) => {
                const v = -y > h * 1.2
                if (ref && ref._top !== v) sBk(ref._top = v);
            });
        }
    }, [ref])


    return <div className={'scroll-view ' + cls} onTouchStart={e => e.stopPropagation()}
                onClick={e => e.stopPropagation()}>
        {!children ? <>
            {status.isDown ? <div className={'loading-top scroll-tip'}><i/><span>正在刷新...</span></div> : null}
            {status.isUp ?
                <div className={'loading-foot scroll-tip'}><i/><span>{end ? '我也是有底线的~' : '正在加载..'}</span></div> : null}
        </> : null}
        {!status.isUp && !status.isDown ? <Loading act={loading}>正在加载</Loading> : null}
        <div className={'scroll-wrapper'} ref={(r) => {
            if (r && r !== ref) setRef(r)
        }}>
            <div className={'scroll-ctx'} ref={a => {
                if (a && ctx.a !== a && ctx.b) ctx.b.refresh()
            }}>
                {children ? children(refresh) : (data && data.length ? data.map(item) : <span>{loading ? '' :
                    <NoDate cls={noData[1]} children={noData[0]}/>}</span>)}
            </div>
        </div>
        {children ? null : <div className={'bc2Top' + (top && toTop ? ' act' : '')} onClick={toTop}/>}
    </div>
}
